(function() {
    'use strict';

    angular
        .module('portalApp')
        .controller('FrequencyDialogController', FrequencyDialogController);

    FrequencyDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Frequency'];

    function FrequencyDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, Frequency) {
        var vm = this;

        vm.frequency = entity;
        vm.clear = clear;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.frequency.id !== null) {
                Frequency.update(vm.frequency, onSaveSuccess, onSaveError);
            } else {
                Frequency.save(vm.frequency, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('portalApp:frequencyUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();
